<template>
  <div class="center_pop" :style="{ height: popHeight }" @touchmove.prevent>
    <div class="authpost_box" v-if="ctPopType == 'authpost'">
      <div class="content_box">
        <div class="title_box">授权请求</div>
        <div class="dec_box">
          本Skill将允许OpenClaw使用您的东方财富账号按照您的要求自动发布内容。请确认您已了解该Skill的预期功能，并同意承担由此产生的发布行为。
        </div>
        <div class="btn_box">
          <div class="cancel_btn" @click="handleCenterPop('')">取消</div>
          <div class="fg_box"></div>
          <div class="confirm_btn" @click="handleCenterPop('authpost')">
            确认启用
          </div>
        </div>
      </div>
    </div>

    <div class="authpost_box" v-if="ctPopType == 'sleepConfim'">
      <div class="content_box">
        <div class="title_box">温馨提示</div>
        <div class="dec_box">
          由于您近期活跃度较低，账户进入休眠状态，基础调用次数调整为10次/天，现已为您自动激活，并恢复基础版调用次数。
        </div>
        <div class="btn_box"> 
          <div class="confirm_btn" @click="handleCenterPop('sleepConfim')">
            我知道了
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  ctPopType: string;
}>();
import { computed, ref } from "vue";

const popHeight = ref("100vh");

const emit = defineEmits(["handleCenterPop"]);

/************************************************** lifecircles **************************************************/

const onCreated = () => {};
onCreated();
import { onMounted, onUnmounted } from "vue";
onMounted(() => {});
onUnmounted(() => {});

/************************************************** methods **************************************************/

const handleCenterPop = (type: string) => {
  emit("handleCenterPop", type);
};
</script>

<style scoped lang="scss">
.center_pop {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 50%;
  width: 7.52rem;
  height: 100%;
  transform: translateX(-50%);
  overflow: hidden;
  z-index: 1000;

  .authpost_box {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .content_box {
      width: 6rem;
      background-size: 100% auto;
      background-color: #fff;
      border-radius: 0.24rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title_box {
        width: 100%;
        text-align: center;
        font-size: 0.36rem;
        font-weight: bold;
        color: #333;
        line-height: 0.52rem;
        margin: 0.38rem auto 0.24rem;
      }
      .dec_box {
        width: 5.04rem;
        line-height: 0.44rem;
        text-align: justify;
        font-size: 0.26rem;
        color: #222222;
        span {
          font-size: 0.32rem;
          font-weight: bold;
        }
      }
      .btn_box {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 1.02rem;
        margin: 0.42rem auto 0;
        border-top: rgba(0, 0, 0, 0.1) 0.02rem solid;

        .cancel_btn {
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 100%;
          color: #333;
          font-size: 0.34rem;
        }
        .fg_box {
          width: 0.02rem;
          height: 0.32rem;
          background-color: rgba(0, 0, 0, 0.1);
        }
        .confirm_btn {
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 100%;
          color: #ff5500;
          font-size: 0.34rem;
        }
      }
    }
  }
}
</style>
